import {
	initObservability,
	logInfo as _logInfo,
	logError as _logError,
	addRumError as _addRumError,
	setUserContext as _setUserContext,
	clearUserContext as _clearUserContext,
	getCorrelationKey as _getCorrelationKey,
	isInitialized as _isInitialized,
	setupAxiosObservability,
	ObservabilityErrorBoundary
} from '@webmotors/anunciar.tools';
import { ENV } from '@/app/config';
import { getBuildVersion } from './build-version';

/**
 * Initializes Datadog RUM + Logs via @webmotors/anunciar.tools.
 *
 * Must be called once at module level (App.tsx), before any component renders.
 * Correlation ID is auto-generated and stored in sessionStorage.
 * All logInfo/logError calls include the correlation_id automatically.
 *
 * Env vars are read from ENV config (sourced from VITE_DATADOG_* vars).
 * In development (empty client token), init is skipped silently by the lib.
 */
const initDatadog = () => {
	initObservability({
		provider: 'datadog',
		config: {
			team: 'anunciar',
			isDev: ENV.APP_ENV === 'development',
			enableRum: true,
			enableLogs: true,
			enableSessionReplayRecording: true,
			shared: {
				clientToken: ENV.DATADOG_CLIENT_TOKEN,
				env: ENV.DATADOG_ENV,
				service: ENV.DATADOG_SERVICE,
				site: ENV.DATADOG_SITE,
				version: getBuildVersion()
			},
			rum: {
				applicationId: ENV.DATADOG_APPLICATION_ID,
				sessionSampleRate: ENV.DATADOG_SESSION_SAMPLE_RATE,
				sessionReplaySampleRate: ENV.DATADOG_SESSION_REPLAY_SAMPLE_RATE,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
				trackUserInteractions: true,
				errorSampling: {
					enabled: true,
					ttlMs: 60_000
				}
			},
			logs: {
				sessionSampleRate: 100
			}
		}
	});
};

/**
 * Re-exported from @webmotors/anunciar.tools.
 * Other modules should import from '@/services/observability' — never directly
 * from the third-party package. This keeps the dependency encapsulated.
 */
const logInfo = _logInfo;
const logError = _logError;
const addRumError = _addRumError;
const setUserContext = _setUserContext;
const clearUserContext = _clearUserContext;
const getCorrelationKey = _getCorrelationKey;
const isInitialized = _isInitialized;

export {
	initDatadog,
	logInfo,
	logError,
	addRumError,
	setUserContext,
	clearUserContext,
	getCorrelationKey,
	isInitialized,
	setupAxiosObservability,
	ObservabilityErrorBoundary
};
